import CustomTableCell from '../CustomTableCell';
import { ICustomTableRowProps } from './interface';

const CustomTableRow = <T,>({
  item,
  columnsMetadata,
  onClick,
  onActionClick
}: ICustomTableRowProps<T>) => {
  const handleClick = (env: any) => {
    if (onClick) {
      const selection = window.getSelection()?.toString() as string;
      const tagName = env.target.tagName;

      if (tagName === 'A') {
        return;
      }

      if (selection.length <= 0) {
        onClick(item);
      }
    }
  };

  return (
    <tr onClick={handleClick}>
      {columnsMetadata.map((column) => (
        <CustomTableCell<T>
          key={column.key}
          onClick={onActionClick}
          item={item}
          columnMetadata={column}
        />
      ))}
    </tr>
  );
};

export default CustomTableRow;
